'use client';

import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';

function SoftShadow() {
  return (
    <Demo
      id="soft-shadow"
      initialValues={{ strength: 50 }}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="strength"
          id="strength"
          label="Blur Amount"
          min={0}
          max={100}
        />,
      ]}
    >
      {({ strength }) => {
        const blur = normalize(strength, 0, 100, 0, 7);
        const opacity = normalize(strength, 0, 100, 0.25, 0.5);

        return (
          <Wrapper>
            <ButtonWrapper
              style={{
                '--blur': blur + 'px',
                '--opacity': opacity,
              }}
            >
              <Shadow />
              <Backdrop />
              <Contents>Push Me</Contents>
            </ButtonWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

function FinalButton({ children }) {
  return (
    <ButtonWrapper>
      <Shadow />
      <Backdrop />
      <Contents>{children}</Contents>
    </ButtonWrapper>
  );
}

const Wrapper = styled.div`
  padding: 32px;
`;

const ButtonWrapper = styled.button`
  position: relative;
  width: 180px;
  text-align: center;
  transition: filter 250ms;

  &:hover {
    filter: brightness(110%);
  }
`;

const Shadow = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: hsl(0deg 0% 0% / var(--opacity));
  border-radius: 12px;
  /* Mouse-out styles */
  transform: translateY(3px);
  transition: transform 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  filter: blur(var(--blur));

  ${Wrapper}:hover &, ${Wrapper}:focus-visible & {
    transform: translateY(4px);
    transition: all 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  }
  ${Wrapper}:active & {
    transform: translateY(1px);
    transition: all 25ms;
  }
`;

const Backdrop = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: hsl(340deg, 100%, 32%);
  /* prettier-ignore */
  background: linear-gradient(
    to left,
    hsl(340deg, 100%, 20%) 0%,
    hsl(340deg, 100%, 32%) 7%,
    hsl(340deg, 100%, 32%) 93%,
    hsl(340deg, 100%, 20%) 100%
  );
  border-radius: 12px;
`;
const Contents = styled.span`
  position: relative;
  display: block;
  background: hsl(345deg, 100%, 46.5%);
  padding: 12px 42px;
  color: white;
  border-radius: 12px;
  backface-visibility: hidden;
  font-weight: bold;
  font-size: 20px;
  /* Mouse-out styles */
  transform: translateY(-4px);
  transition: all 600ms cubic-bezier(0.3, 0.7, 0.4, 1);

  ${Wrapper}:hover &, ${Wrapper}:focus-visible & {
    transform: translateY(-6px);
    transition: all 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  }
  ${Wrapper}:active & {
    transform: translateY(-2px);
    transition: all 25ms;
  }
`;

export default SoftShadow;
